module.exports = __webpack_public_path__ + "img/3.797ba239.png";